<template>
  <v-container>
    <v-row>
      <v-spacer></v-spacer>
      <div>
          This page hasn't been written yet.

          <br />
          <br />
          If you have an add-able link click that link to enable adding this page.

      </div>
      <v-spacer></v-spacer>
    </v-row>

    <v-row class="mt-3">
      <v-spacer></v-spacer>
      <a @click="$router.go(-1)">Go back to the last page.</a>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <span class="red--text">{{errtext}}</span>
      <v-spacer></v-spacer>
    </v-row>

  </v-container>
</template>

<script>

export default {
  name: 'CannotEdit',
  data: () => ({
    loading: false,
    errtext: null

  }),
  mounted () {
  },
  methods: {

  }
}
</script>
